import { render, staticRenderFns } from "./Ausencias.vue?vue&type=template&id=01cda06f"
import script from "./Ausencias.vue?vue&type=script&lang=js"
export * from "./Ausencias.vue?vue&type=script&lang=js"
import style0 from "./Ausencias.vue?vue&type=style&index=0&id=01cda06f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports